module.exports = __webpack_public_path__ + "static/media/monster-style-sundae@2x.b51422d9.png";